import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { AmplitudeContext } from '@homebot/shared-util-quartermaster'

// Contexts
import { useTheme } from '@homebot/shared-ui-swashbuckle'

// Constants
import { EMERGENCY_RESERVE } from '../../../../../constants/gems'
import { OVERLAY_HELPERS } from '../../../../../constants/navigation'

// Selectors
import { selectEmergencyReservePool } from '../../../../../store/selectors/home/equity'

// Components
import { Text, Format } from '../../../..'
import ImportantNowCard from '../../ImportantNowCard'

// Assets
import DefaultThemeSvg from './DefaultThemeSvg'
import LightThemeSvg from './LightThemeSvg'
import { RESERVE_WIN } from '../../../../../constants/wins'

const Reserve = () => {
  const reserveAmount = useSelector(selectEmergencyReservePool)
  const { ampli } = useContext(AmplitudeContext)

  const { theme } = useTheme()

  const Svg = theme.isLightThemeType ? LightThemeSvg : DefaultThemeSvg

  return (
    <ImportantNowCard
      name='Reserve'
      event={() => ampli?.winClicked({ win_type: RESERVE_WIN })}
      svgImage={Svg}
      navTo={OVERLAY_HELPERS.cashout.buildPath(EMERGENCY_RESERVE)}
    >
      <FormattedMessage
        id='ImportantNow.spotlight.reserve'
        defaultMessage='You could use about {bold} of equity to feel more ready for a storm'
        values={{
          bold: (
            <Text element='span' weight='semibold' variant='success'>
              <Format.Currency value={reserveAmount} abbreviate />
            </Text>
          ),
        }}
      />
    </ImportantNowCard>
  )
}

Reserve.propTypes = {}

export default Reserve
